import { useRoutes } from "react-router-dom";
import {
  LoginScreen,
  NewPasswordScreen,
  RecoverPasswordScreen,
} from "@portal/access";
import { portalRoutes } from "@portal/shell/routes";
import { ToastProvider } from "@portal/common";
import { FoundationPrimitivesGallery } from "@portal/common/FoundationPrimitivesGallery";

// SPEC-221: pantalla de acceso real (usuario/contraseña, recuperación y
// nueva contraseña). IdleSessionGuard y RequirePasswordChange redirigen acá.
const accessRoutes = [
  { path: "access", element: <LoginScreen /> },
  { path: "access/recover", element: <RecoverPasswordScreen /> },
  { path: "access/new-password", element: <NewPasswordScreen /> },
];

export function PortalApp() {
  const foundationRoutes = import.meta.env.DEV
    ? [
        {
          path: "__foundation/primitives",
          element: <FoundationPrimitivesGallery />,
        },
      ]
    : [];
  const element = useRoutes([
    ...foundationRoutes,
    ...accessRoutes,
    ...portalRoutes,
  ]);
  return <ToastProvider>{element}</ToastProvider>;
}
